import { HouseDataType, ListingType, PropertyMarketingContent } from "./types";

// Random popup configuration
export const RANDOM_POPUP_CONFIG = {
  // Probability of showing the popup (0-1, where 1 = 100% chance)
  showProbability: 1, // 30% chance to show 
  
  // Time range in milliseconds for random delay
  minDelay: 25000, 
  maxDelay: 50000, 
  
  // Duration the popup stays visible
  duration: 8000, // 8 seconds
  
  // Messages for different languages
  messages: {
    en: "Recent guests booked directly on our website.",
    es: "Huéspedes recientes reservaron directamente en nuestra web."
  }
};

export interface IImageDescription {
    roomType: string;
    roomDescription: string;
    imageLink?: string;
}
export const homesSnippet: ListingType[] = [
    {
        name: 'Tucano',
        mainImage: "https://drive.google.com/thumbnail?id=10qvLOMLs4_JsBIF99igVeh4baDR7EB-Q&sz=w1000"
    },
    {
        name: 'Geco',
        mainImage: "https://drive.google.com/thumbnail?id=1tYQxiwEXhxhv2r0_mJQhXVAHOMrE0y_2&sz=w1000"
    },
    {
        name: 'Pappagallo',
        mainImage: "https://drive.google.com/thumbnail?id=1owhxss4VVXLLJAQP1ByDyBMH_NwQsIuY&sz=w1000"
    },
    {
        name: 'Rana',
        mainImage: "https://drive.google.com/thumbnail?id=1UiGI8gFf6UR5kn8Eo30u457NX8NkP95X&sz=w1000"
    },
    {
        name: 'Delfin',
        mainImage: "https://drive.google.com/thumbnail?id=1ui0cNzHTb2WM-k59OkwnJXw77m0P7PPW&sz=w1000"
    },
]
export const NamSnippet: ListingType[] = [
    {
        name: 'Areka',
        mainImage: "https://drive.google.com/thumbnail?id=1iHyOve78WkDNdTcQcUtKkiM8rXx2iRey&sz=w1000"
    },
    {
        name: 'Giulia',
        mainImage: "https://drive.google.com/thumbnail?id=1e0esqkSBKBdT-F2kLg5PsyF46zEWtWQ8&sz=w1000"
    },
    {
        name: 'Plumeria',
        mainImage: "https://drive.google.com/thumbnail?id=1b2x2aVIjqlSws4KePOS_NVb4NItGsra1&sz=w1000"
    },
]
export const NamSnippetES: ListingType[] = [
    {
        name: 'ArekaES',
        mainImage: "https://drive.google.com/thumbnail?id=1iHyOve78WkDNdTcQcUtKkiM8rXx2iRey&sz=w1000"
    },
    {
        name: 'GiuliaES',
        mainImage: "https://drive.google.com/thumbnail?id=1e0esqkSBKBdT-F2kLg5PsyF46zEWtWQ8&sz=w1000"
    },
    {
        name: 'PlumeriaES',
        mainImage: "https://drive.google.com/thumbnail?id=1b2x2aVIjqlSws4KePOS_NVb4NItGsra1&sz=w1000"
    },
]
export const VillaSnippet: ListingType[] = [
    {
        name: 'Villa Mar',
        mainImage: "https://drive.google.com/thumbnail?id=1cl5zzeKajmxVv5_q9cH0cvYQkCRl6kCn&sz=w1000"
    },
    {
        name: 'Villa Coral',
        mainImage: "https://drive.google.com/thumbnail?id=1frKDGGLk1nJQQaxoxng6TgmUVzxTx08A&sz=w1000"
    }
]

export const VillaMarSnippet: ListingType[] = [
    {
        name: 'Villa Coral',
        mainImage: "https://drive.google.com/thumbnail?id=1frKDGGLk1nJQQaxoxng6TgmUVzxTx08A&sz=w1000"
    }
]

export const VillaCoralSnippet: ListingType[] = [
    {
        name: 'Villa Mar',
        mainImage: "https://drive.google.com/thumbnail?id=1cl5zzeKajmxVv5_q9cH0cvYQkCRl6kCn&sz=w1000"
    }
]

export const allHomesSnippet: ListingType[] = [
    {
        name: 'Pappagallo',
        mainImage: "https://drive.google.com/thumbnail?id=1owhxss4VVXLLJAQP1ByDyBMH_NwQsIuY&sz=w1000"
    },
    {
        name: 'Geco',
        mainImage: "https://drive.google.com/thumbnail?id=1tYQxiwEXhxhv2r0_mJQhXVAHOMrE0y_2&sz=w1000"
    },
    {
        name: 'Plumeria',
        mainImage: "https://drive.google.com/thumbnail?id=1b2x2aVIjqlSws4KePOS_NVb4NItGsra1&sz=w1000"
    },
    {
        name: 'Giulia',
        mainImage: "https://drive.google.com/thumbnail?id=1e0esqkSBKBdT-F2kLg5PsyF46zEWtWQ8&sz=w1000"
    },
    {
        name: 'Villa Coral',
        mainImage: "https://drive.google.com/thumbnail?id=1frKDGGLk1nJQQaxoxng6TgmUVzxTx08A&sz=w1000"
    }
]

export const allHomesSnippetES: ListingType[] = [
    {
        name: 'PappagalloES',
        mainImage: "https://drive.google.com/thumbnail?id=1owhxss4VVXLLJAQP1ByDyBMH_NwQsIuY&sz=w1000"
    },
    {
        name: 'GecoES',
        mainImage: "https://drive.google.com/thumbnail?id=1tYQxiwEXhxhv2r0_mJQhXVAHOMrE0y_2&sz=w1000"
    },
    {
        name: 'PlumeriaES',
        mainImage: "https://drive.google.com/thumbnail?id=1b2x2aVIjqlSws4KePOS_NVb4NItGsra1&sz=w1000"
    },
    {
        name: 'GiuliaES',
        mainImage: "https://drive.google.com/thumbnail?id=1e0esqkSBKBdT-F2kLg5PsyF46zEWtWQ8&sz=w1000"
    },
    {
        name: 'VillaCoralES',
        mainImage: "https://drive.google.com/thumbnail?id=1frKDGGLk1nJQQaxoxng6TgmUVzxTx08A&sz=w1000"
    }
]
export const gecoImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Baño",
        roomDescription: "Siempre proporcionamos toallas y artículos de aseo.",
        imageLink: "https://drive.google.com/thumbnail?id=1ocQCVEUW8VFMUjgb6bByd56EF8cqIZzS&sz=w1000"
    },
    {
        roomType: "Segundo Dormitorio",
        roomDescription: "Ropa de cama siempre incluida.",
        imageLink: "https://drive.google.com/thumbnail?id=1pKfUX6k4hl-Idbio56J-QUge0KRrCJ91&sz=w1000"
    },
    {
        roomType: "Cocina",
        roomDescription: "Microondas, cafetera y licuadora incluidos.",
        imageLink: "https://drive.google.com/thumbnail?id=1QBjP84LxcmegtOn_GtIJKFxi8R2ie_Yk&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "No olvides nuestro 15% de descuento en cada compra en la panadería, hay menús en la casa.",
        imageLink: "https://drive.google.com/thumbnail?id=1O5hZ0VJhFspi3SvXWUuOJZl82ozQ18rp&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "100Mbps de Wifi gratis en toda tu casa.",
        imageLink: "https://drive.google.com/thumbnail?id=1YnACZpnj9I9GgDqZxx0brHIKjdqwu0VT&sz=w1000"
    },
    {
        roomType: "Cuarto Principal",
        roomDescription: "Esta habitación tiene un televisor con un sistema de entretenimiento Roku y puerto HDMI.",
        imageLink: "https://drive.google.com/thumbnail?id=1fbmZQn38bbH_t5Hu0x_vYfQWIuiIIN9W&sz=w1000"
    },
    {
        roomType: "Jardín",
        roomDescription: "Hay estacionamiento privado gratuito en este lugar.",
        imageLink: "https://drive.google.com/thumbnail?id=10brlXHpVyjQmum0BZcobJ6s4huT8My7t&sz=w1000"
    },
    {
        roomType: "Porche",
        roomDescription: "Todos los espacios mostrados son completamente privados, solo para ti.",
        imageLink: "https://drive.google.com/thumbnail?id=1ExyU9JUIgahhBykI4ugoJYkS9ybF2F8-&sz=w1000"
    }
]
export const pappagalloImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Baño",
        roomDescription: "Siempre proporcionamos toallas y artículos de aseo.",
        imageLink: "https://drive.google.com/thumbnail?id=1qocAtWUCMRttBmWa8fP_KtJDW-5QD6jh&sz=w1000"
    },
    {
        roomType: "Cuarto Principal",
        roomDescription: "Esta habitación tiene un televisor con un sistema de entretenimiento Roku y puerto HDMI.",
        imageLink: "https://drive.google.com/thumbnail?id=1s3MfwR3l7yme47d7IrqSEDYPNMWRzpPh&sz=w1000"
    },
    {
        roomType: "Segundo Dormitorio",
        roomDescription: "Ropa de cama siempre incluida.",
        imageLink: "https://drive.google.com/thumbnail?id=1WGdWpqS0BpOGo6AMhHGocp1jN1OSIPDQ&sz=w1000"
    },
    {
        roomType: "Cocina",
        roomDescription: "Microondas, cafetera y licuadora incluidos.",
        imageLink: "https://drive.google.com/thumbnail?id=1bpwpewoUw6CuYg66IcwpbcCm2Ne1Ryth&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "No olvides nuestro 15% de descuento en cada compra en la panadería, hay menús en la casa.",
        imageLink: "https://drive.google.com/thumbnail?id=1dz1y_lAZTfzvj2862Gahw5QY-w4_FjOX&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "100Mbps de Wifi gratis en toda tu casa.",
        imageLink: "https://drive.google.com/thumbnail?id=1IGjxWxvODVY5BgAIS21MNxZaCev4qKx5&sz=w1000"
    },
    {
        roomType: "Balcón",
        roomDescription: "Casa Pappagallo y Casa Tucano fueron remodeladas en el 2021.",
        imageLink: "https://drive.google.com/thumbnail?id=16GIFWl5alQgk32AkQdJNsyLGMwDtfdsO&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "Shh... ¡No te lo pierdas! ¡Ingresa el codigo #5off para un descuento extra a la hora de reservar con nosotros!",
        imageLink: "https://drive.google.com/thumbnail?id=1yrtj6UM8z-lCu_8inK_nn37p3kzaFIwY&sz=w1000"
    }
]
export const ranaImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Baño",
        roomDescription: "Siempre proporcionamos toallas y artículos de aseo.",
        imageLink: "https://drive.google.com/thumbnail?id=1N_nhyc-LysiQ5lJo7p6vPRDKviJE2QCO&sz=w1000"
    },
    {
        roomType: "Baño",
        roomDescription: "Siempre estamos disponibles para ayudarte con cualquier pregunta o inquietud que puedas tener.",
        imageLink: "https://drive.google.com/thumbnail?id=1igbIdHZHFVZybTUbI9Ih0AQmjyTT7Y27&sz=w1000"
    },
    {
        roomType: "Cuarto Principal",
        roomDescription: "Esta habitación tiene un televisor con un sistema de entretenimiento Roku y puerto HDMI.",
        imageLink: "https://drive.google.com/thumbnail?id=1Du7hhx0X7ry3QXVFNPBP9LU6ItquZMtV&sz=w1000"
    },
    {
        roomType: "Cuarto Principal",
        roomDescription: "Colchones de 10pulgadas/25cm.",
        imageLink: "https://drive.google.com/thumbnail?id=1Dbna1MUEB126_-QfkRLVVgha6553hQc_&sz=w1000"
    },
    {
        roomType: "Segundo Dormitorio",
        roomDescription: "Ropa de cama siempre incluida.",
        imageLink: "https://drive.google.com/thumbnail?id=1phVUR1WvBJmYT2Anr1BEUhwniwApu0TL&sz=w1000"
    },
    {
        roomType: "Cocina",
        roomDescription: "Microondas, cafetera y licuadora incluidos.",
        imageLink: "https://drive.google.com/thumbnail?id=1HLpqPwUgdTuhP8TfNuFOk2slUPtYNBPP&sz=w1000"
    },
    {
        roomType: "Cocina",
        roomDescription: "Ofrecemos descuentos last-minute para reservas de último minuto.",
        imageLink: "https://drive.google.com/thumbnail?id=10KgLUm_WUcN-GWFvfN52T0j6ckfTvj9G&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "100Mbps de Wifi gratis en toda tu casa.",
        imageLink: "https://drive.google.com/thumbnail?id=1UFvJsslx0lQbvGVuEy07mClIw1VS75j0&sz=w1000"
    },
    {
        roomType: "Jardín",
        roomDescription: "Parqueo privado gratuito disponible en este lugar.",
        imageLink: "https://drive.google.com/thumbnail?id=1vzDKoJQ8fQEHXGXFL525sXJ77ZHbGCNO&sz=w1000"
    }
]
export const delfinImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Terraza",
        roomDescription: "Siempre proporcionamos toallas y artículos de aseo.",
        imageLink: "https://drive.google.com/thumbnail?id=1ui0cNzHTb2WM-k59OkwnJXw77m0P7PPW&sz=w1000"
    },
    {
        roomType: "Baño",
        roomDescription: "Siempre estamos disponibles para ayudarte con cualquier pregunta o inquietud que puedas tener.",
        imageLink: "https://drive.google.com/thumbnail?id=1QxWsMW8dh5m19DGv1ZBKCcifzHMxs9R9&sz=w1000"
    },
    {
        roomType: "Cuarto Principal",
        roomDescription: "Esta habitación tiene un televisor con un sistema de entretenimiento Roku y puerto HDMI.",
        imageLink: "https://drive.google.com/thumbnail?id=166BAE3B571U-S2gRWTNideuHdpXE95c7&sz=w1000"
    },
    {
        roomType: "Cuarto Principal",
        roomDescription: "Colchones de 10pulgadas/25cm.",
        imageLink: "https://drive.google.com/thumbnail?id=1Vp74GumnGJuxjlJEziS7ktA-Du9UHlov&sz=w1000"
    },
    {
        roomType: "Segundo Dormitorio",
        roomDescription: "Ropa de cama siempre incluida.",
        imageLink: "https://drive.google.com/thumbnail?id=14tRFJRifJruesH1iCUCJAeKrQ9wS0cqP&sz=w1000"
    },
    {
        roomType: "Cocina",
        roomDescription: "Microondas, cafetera y licuadora incluidos.",
        imageLink: "https://drive.google.com/thumbnail?id=1dLwcs8QzF6YiGWBGhnDpO6hMj1VtMbIh&sz=w1000"
    },
    {
        roomType: "Cocina",
        roomDescription: "Ofrecemos descuentos last-minute para reservas de último minuto.",
        imageLink: "https://drive.google.com/thumbnail?id=1fTFQ9jumREu-O6Vs2M_7Q6AlWkCJKjYn&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "100Mbps de Wifi gratis en toda tu casa.",
        imageLink: "https://drive.google.com/thumbnail?id=1iRP_x0A6BprRBnQ0yWE6a2sa3tPiKIOQ&sz=w1000"
    },
    {
        roomType: "Jardín",
        roomDescription: "Parqueo privado gratuito disponible en este lugar.",
        imageLink: "https://drive.google.com/thumbnail?id=1Zm3lah2psnATqL6UcWB2Jwu0IncFjDnX&sz=w1000"
    }
]
export const tucanoImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Baño",
        roomDescription: "Siempre proporcionamos toallas y artículos de aseo.",
        imageLink: "https://drive.google.com/thumbnail?id=1SC7QClrubrzsRyiz9igW5oIDiIgdDmeg&sz=w1000"
    },
    {
        roomType: "Baño",
        roomDescription: "Ofrecemos limpieza gratuita para reservas más largas.",
        imageLink: "https://drive.google.com/thumbnail?id=1aiADCh7t1taZ9yFcNfGg3Gpl-IPVabxA&sz=w1000"
    },
    {
        roomType: "Cuarto Principal",
        roomDescription: "Esta habitación tiene un televisor con un sistema de entretenimiento Roku y puerto HDMI.",
        imageLink: "https://drive.google.com/thumbnail?id=12d5__pqzKjeffa0joFLeZn4kTPvJVXE_&sz=w1000"
    },
    {
        roomType: "Cuarto Principal",
        roomDescription: "Colchones de 10pulgadas/25cm.",
        imageLink: "https://drive.google.com/thumbnail?id=16Gd2y03TpdFCVY2ugTbV3d0R-YrOj2bf&sz=w1000"
    },
    {
        roomType: "Segundo Dormitorio",
        roomDescription: "Ropa de cama siempre incluida.",
        imageLink: "https://drive.google.com/thumbnail?id=1CkNL9edZ-a2LVEZZ4dawAhCAB89d29st&sz=w1000"
    },
    {
        roomType: "Cocina",
        roomDescription: "Microondas, cafetera y licuadora incluidos.",
        imageLink: "https://drive.google.com/thumbnail?id=17CUhGccaCV33gbEv4Yt3-Co3vCuOiiyx&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "100Mbps de Wifi gratis en toda tu casa.",
        imageLink: "https://drive.google.com/thumbnail?id=16ZLKp3PnfxXbQv_4BD9VbYbr_7_gfyJJ&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "No olvides nuestro 15% de descuento en cada compra en la panadería, hay menús en la casa.",
        imageLink: "https://drive.google.com/thumbnail?id=1cp4slCoNdbsJhbReAPlKkOOqpvqTDTVy&sz=w1000"
    },
    {
        roomType: "Balcón",
        roomDescription: "Todos los espacios mostrados son completamente privados, solo para ti.",
        imageLink: "https://drive.google.com/thumbnail?id=1ltpPKGHG46Rl_pTpnTtewt2U3YsKwr8W&sz=w1000"
    }
]


export const gecoImageDescriptions: IImageDescription[] = [
    {
        roomType: "Bathroom",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1ocQCVEUW8VFMUjgb6bByd56EF8cqIZzS&sz=w1000"
    },
    {
        roomType: "Second Bedroom",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1pKfUX6k4hl-Idbio56J-QUge0KRrCJ91&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1QBjP84LxcmegtOn_GtIJKFxi8R2ie_Yk&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "Don't forget about our 15% discount for every purchase at the bakery, there are menus in the house.",
        imageLink: "https://drive.google.com/thumbnail?id=1O5hZ0VJhFspi3SvXWUuOJZl82ozQ18rp&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1YnACZpnj9I9GgDqZxx0brHIKjdqwu0VT&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "This room has a TV with a Roku Entertainment System and HDMI port.",
        imageLink: "https://drive.google.com/thumbnail?id=1fbmZQn38bbH_t5Hu0x_vYfQWIuiIIN9W&sz=w1000"
    },
    {
        roomType: "Garden",
        roomDescription: "Free private parking is available at this location.",
        imageLink: "https://drive.google.com/thumbnail?id=10brlXHpVyjQmum0BZcobJ6s4huT8My7t&sz=w1000"
    },
    {
        roomType: "Front Porch",
        roomDescription: "All the spaces shown are completely private, for you only.",
        imageLink: "https://drive.google.com/thumbnail?id=1ExyU9JUIgahhBykI4ugoJYkS9ybF2F8-&sz=w1000"
    }
]
export const pappagalloImageDescriptions: IImageDescription[] = [
    {
        roomType: "Bathroom",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1qocAtWUCMRttBmWa8fP_KtJDW-5QD6jh&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "This room has a TV with a Roku Entertainment System of channels and HDMI port.",
        imageLink: "https://drive.google.com/thumbnail?id=1s3MfwR3l7yme47d7IrqSEDYPNMWRzpPh&sz=w1000"
    },
    {
        roomType: "Second Bedroom",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1WGdWpqS0BpOGo6AMhHGocp1jN1OSIPDQ&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1bpwpewoUw6CuYg66IcwpbcCm2Ne1Ryth&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1dz1y_lAZTfzvj2862Gahw5QY-w4_FjOX&sz=w1000"
    },
    {
        roomType: "Living Room",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1IGjxWxvODVY5BgAIS21MNxZaCev4qKx5&sz=w1000"
    },
    {
        roomType: "Balcony",
        roomDescription: "Casa Tucano and Casa Pappagallo were remodeled by an interior designer from spain, in June 2021.",
        imageLink: "https://drive.google.com/thumbnail?id=16GIFWl5alQgk32AkQdJNsyLGMwDtfdsO&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "Shh... Secret discount! Use discount code #5off to get an additional discount!",
        imageLink: "https://drive.google.com/thumbnail?id=1yrtj6UM8z-lCu_8inK_nn37p3kzaFIwY&sz=w1000"
    }
]
export const ranaImageDescriptions: IImageDescription[] = [
    {
        roomType: "Bathroom",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1-ZKRoDNGsf7J1DMw-J5RI8H4HFlgVAuT&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "We're available 24/7 in case you need any help.",
        imageLink: "https://drive.google.com/thumbnail?id=1igbIdHZHFVZybTUbI9Ih0AQmjyTT7Y27&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "This room has a TV with a Roku Entertainment System and HDMI port.",
        imageLink: "https://drive.google.com/thumbnail?id=1Du7hhx0X7ry3QXVFNPBP9LU6ItquZMtV&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "10inches/25cm tall matresses in every house.",
        imageLink: "https://drive.google.com/thumbnail?id=1Dbna1MUEB126_-QfkRLVVgha6553hQc_&sz=w1000"
    },
    {
        roomType: "Second Bedroom",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1phVUR1WvBJmYT2Anr1BEUhwniwApu0TL&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1HLpqPwUgdTuhP8TfNuFOk2slUPtYNBPP&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "We offer last-minute discounts, prices are updated daily!",
        imageLink: "https://drive.google.com/thumbnail?id=10KgLUm_WUcN-GWFvfN52T0j6ckfTvj9G&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1UFvJsslx0lQbvGVuEy07mClIw1VS75j0&sz=w1000"
    },
    {
        roomType: "Garden",
        roomDescription: "Free private parking is available at this location.",
        imageLink: "https://drive.google.com/thumbnail?id=1vzDKoJQ8fQEHXGXFL525sXJ77ZHbGCNO&sz=w1000"
    }
]
export const delfinImageDescriptions: IImageDescription[] = [
    {
        roomType: "Bathroom",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1ui0cNzHTb2WM-k59OkwnJXw77m0P7PPW&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "We're available 24/7 in case you need any help.",
        imageLink: "https://drive.google.com/thumbnail?id=1QxWsMW8dh5m19DGv1ZBKCcifzHMxs9R9&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "This room has a TV with a Roku Entertainment System and HDMI port.",
        imageLink: "https://drive.google.com/thumbnail?id=166BAE3B571U-S2gRWTNideuHdpXE95c7&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "10inches/25cm tall matresses in every house.",
        imageLink: "https://drive.google.com/thumbnail?id=1Vp74GumnGJuxjlJEziS7ktA-Du9UHlov&sz=w1000"
    },
    {
        roomType: "Second Bedroom",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=14tRFJRifJruesH1iCUCJAeKrQ9wS0cqP&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1dLwcs8QzF6YiGWBGhnDpO6hMj1VtMbIh&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "We offer last-minute discounts, prices are updated daily!",
        imageLink: "https://drive.google.com/thumbnail?id=1fTFQ9jumREu-O6Vs2M_7Q6AlWkCJKjYn&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1iRP_x0A6BprRBnQ0yWE6a2sa3tPiKIOQ&sz=w1000"
    },
    {
        roomType: "Garden",
        roomDescription: "Free private parking is available at this location.",
        imageLink: "https://drive.google.com/thumbnail?id=1Zm3lah2psnATqL6UcWB2Jwu0IncFjDnX&sz=w1000"
    }
]
export const tucanoImageDescriptions: IImageDescription[] = [
    {
        roomType: "Bathroom",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1SC7QClrubrzsRyiz9igW5oIDiIgdDmeg&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "We offer free cleaning services for longer reservations.",
        imageLink: "https://drive.google.com/thumbnail?id=1aiADCh7t1taZ9yFcNfGg3Gpl-IPVabxA&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "This room has a TV with hundreds of channels and HDMI port.",
        imageLink: "https://drive.google.com/thumbnail?id=12d5__pqzKjeffa0joFLeZn4kTPvJVXE_&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "10inches/25cm tall matresses in every house.",
        imageLink: "https://drive.google.com/thumbnail?id=16Gd2y03TpdFCVY2ugTbV3d0R-YrOj2bf&sz=w1000"
    },
    {
        roomType: "Second Bedroom",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1CkNL9edZ-a2LVEZZ4dawAhCAB89d29st&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=17CUhGccaCV33gbEv4Yt3-Co3vCuOiiyx&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=16ZLKp3PnfxXbQv_4BD9VbYbr_7_gfyJJ&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "Don't forget about our 15% discount for every purchase at the bakery, there are menus in the house.",
        imageLink: "https://drive.google.com/thumbnail?id=1cp4slCoNdbsJhbReAPlKkOOqpvqTDTVy&sz=w1000"
    },
    {
        roomType: "Balcony",
        roomDescription: "All the spaces shown are completely private, for you only.",
        imageLink: "https://drive.google.com/thumbnail?id=1ltpPKGHG46Rl_pTpnTtewt2U3YsKwr8W&sz=w1000"
    }
]
export const VillaCoralImageDescriptions: IImageDescription[] = [
    {
        roomType: "Private Pool",
        roomDescription: "Exclusive for your use only.",
        imageLink: "https://drive.google.com/thumbnail?id=1rTXsdqpCJQd-rNDma56gWuPgUiVkG4q7&sz=w1000"
    },
    {
        roomType: "Living Room and Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=13FO4GX8mxrPWVvYxgxZwLSoX562YeZ6o&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "King size bed, 10inches thick mattress.",
        imageLink: "https://drive.google.com/thumbnail?id=1fbYlrrmzPPi4qUCZcCWRBZI_T-NoT_0f&sz=w1000"
    },
    {
        roomType: "Living Room",
        roomDescription: "Dedicated workspace with ethernet connection.",
        imageLink: "https://drive.google.com/thumbnail?id=1jnHMs9RZ2W8v7QbwAUpqTahjSEiGogej&sz=w1000"
    },
    {
        roomType: "Porch",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1iampS1euhTWcvffX6G_4aUCT0tEYBiBZ&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1SvQcVu19OTlW4ShyWYosrgo4d9XLjpUO&sz=w1000"
    },
    {
        roomType: "Terrace And Pool",
        roomDescription: "All the spaces shown are completely private, for you only.",
        imageLink: "https://drive.google.com/thumbnail?id=1frKDGGLk1nJQQaxoxng6TgmUVzxTx08A&sz=w1000"
    }
]
export const VillaMarImageDescriptions: IImageDescription[] = [
    {
        roomType: "Private Pool",
        roomDescription: "Exclusive for your use only.",
        imageLink: "https://drive.google.com/thumbnail?id=1hDvSUejFzrKK7Kwx_GxG_Wo4FmUMJya7&sz=w1000"
    },
    {
        roomType: "Living Room and Kitchen",
        roomDescription: "We offer cleaning services for longer reservations.",
        imageLink: "https://drive.google.com/thumbnail?id=1uCajab8qKPf7u-uCluPMo_mWCB5Ibizd&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "King size bed, 10inches thick mattress.",
        imageLink: "https://drive.google.com/thumbnail?id=1r0sHB3CvdgpgYxDJ5ZT3GPhsROTTH2cN&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1yO4pIi_zhNEMUdC21MbfRPM-MYblazLt&sz=w1000"
    },
    {
        roomType: "Porch",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1tDBJjDp1rwG_A7ZmjHFSIQKT6FvRJyx_&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1SvQcVu19OTlW4ShyWYosrgo4d9XLjpUO&sz=w1000"
    },
    {
        roomType: "Terrace And Pool",
        roomDescription: "All the spaces shown are completely private, for you only.",
        imageLink: "https://drive.google.com/thumbnail?id=1cl5zzeKajmxVv5_q9cH0cvYQkCRl6kCn&sz=w1000"
    }
]
export const VillaCoralImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Piscina Privada",
        roomDescription: "Exclusiva para su uso solamente.",
        imageLink: "https://drive.google.com/thumbnail?id=1rTXsdqpCJQd-rNDma56gWuPgUiVkG4q7&sz=w1000"
    },
    {
        roomType: "Sala de Estar y Cocina",
        roomDescription: "Microondas, cafetera y licuadora también incluidos.",
        imageLink: "https://drive.google.com/thumbnail?id=13FO4GX8mxrPWVvYxgxZwLSoX562YeZ6o&sz=w1000"
    },
    {
        roomType: "Habitación Principal",
        roomDescription: "Cama king size, colchón de 10 pulgadas de grosor.",
        imageLink: "https://drive.google.com/thumbnail?id=1fbYlrrmzPPi4qUCZcCWRBZI_T-NoT_0f&sz=w1000"
    },
    {
        roomType: "Sala de Estar",
        roomDescription: "Espacio de trabajo dedicado con conexión Ethernet.",
        imageLink: "https://drive.google.com/thumbnail?id=1jnHMs9RZ2W8v7QbwAUpqTahjSEiGogej&sz=w1000"
    },
    {
        roomType: "Porche",
        roomDescription: "Ropa de cama siempre incluida.",
        imageLink: "https://drive.google.com/thumbnail?id=1iampS1euhTWcvffX6G_4aUCT0tEYBiBZ&sz=w1000"
    },
    {
        roomType: "Baño",
        roomDescription: "Wifi gratuito de 100 Mbps en toda la casa.",
        imageLink: "https://drive.google.com/thumbnail?id=1SvQcVu19OTlW4ShyWYosrgo4d9XLjpUO&sz=w1000"
    },
    {
        roomType: "Terraza y Piscina",
        roomDescription: "Todos los espacios mostrados son completamente privados, solo para usted.",
        imageLink: "https://drive.google.com/thumbnail?id=1frKDGGLk1nJQQaxoxng6TgmUVzxTx08A&sz=w1000"
    }
]

export const VillaMarImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Piscina Privada",
        roomDescription: "Exclusiva para su uso solamente.",
        imageLink: "https://drive.google.com/thumbnail?id=1hDvSUejFzrKK7Kwx_GxG_Wo4FmUMJya7&sz=w1000"
    },
    {
        roomType: "Sala de Estar y Cocina",
        roomDescription: "Ofrecemos servicios de limpieza para reservas largas.",
        imageLink: "https://drive.google.com/thumbnail?id=1uCajab8qKPf7u-uCluPMo_mWCB5Ibizd&sz=w1000"
    },
    {
        roomType: "Habitación Principal",
        roomDescription: "Cama king size, colchón de 10 pulgadas de grosor.",
        imageLink: "https://drive.google.com/thumbnail?id=1r0sHB3CvdgpgYxDJ5ZT3GPhsROTTH2cN&sz=w1000"
    },
    {
        roomType: "Cocina",
        roomDescription: "Microondas, cafetera y licuadora también incluidos.",
        imageLink: "https://drive.google.com/thumbnail?id=1yO4pIi_zhNEMUdC21MbfRPM-MYblazLt&sz=w1000"
    },
    {
        roomType: "Porche",
        roomDescription: "Ropa de cama siempre incluida.",
        imageLink: "https://drive.google.com/thumbnail?id=1tDBJjDp1rwG_A7ZmjHFSIQKT6FvRJyx_&sz=w1000"
    },
    {
        roomType: "Baño",
        roomDescription: "Wifi gratuito de 100 Mbps en toda la casa.",
        imageLink: "https://drive.google.com/thumbnail?id=1SvQcVu19OTlW4ShyWYosrgo4d9XLjpUO&sz=w1000"
    },
    {
        roomType: "Terraza y Piscina",
        roomDescription: "Todos los espacios mostrados son completamente privados, solo para usted.",
        imageLink: "https://drive.google.com/thumbnail?id=1cl5zzeKajmxVv5_q9cH0cvYQkCRl6kCn&sz=w1000"
    }
]
export const ArekaImageDescriptions: IImageDescription[] = [
    {
        roomType: "Bedroom",
        roomDescription: "",
        imageLink: "https://drive.google.com/thumbnail?id=1LJSpQlE5C5C42FEz7M91Pjv4q7QRi-z6&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "We always provide towels and toiletries. ",
        imageLink: "https://drive.google.com/thumbnail?id=1K4SdPnue6pq2HloAAqiS1WZXmc2TlTGb&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1JLwZIir6MROytS_WMo1anNRyXcbEikJf&sz=w1000"
    },
    {
        roomType: "Garden",
        roomDescription: "Free private parking",
        imageLink: "https://drive.google.com/thumbnail?id=1WhqgYtaq3igaScss30mUr9Vm9xF67Sxn&sz=w1000"
    },
    {
        roomType: "Terrace",
        roomDescription: "We offer last-minute discounts, prices are updated daily!",
        imageLink: "https://drive.google.com/thumbnail?id=10OwN88Pw4C-8CvALS8tz7Tor_Vt1RO6J&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1qJrVlpa3UVaLStmjI53Znn11wnD4k90G&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "",
        imageLink: "https://drive.google.com/thumbnail?id=1rERWm7sKifYsdz365dQE1ZFOO2un22tc&sz=w1000"
    },
    {
        roomType: "Bethroom",
        roomDescription: "10inches/25cm tall matresses in every house.",
        imageLink: "https://drive.google.com/thumbnail?id=1MATVhjV7Y1GUS9mAB0RPZDr7kQEVTM3V&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "We're available 24/7 in case you need any help.",
        imageLink: "https://drive.google.com/thumbnail?id=1sDCA9Limfi4RLW2alJF7Avk37ZLinAue&sz=w1000"
    },

]
export const ArekaImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Baño",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1-ZKRoDNGsf7J1DMw-J5RI8H4HFlgVAuT&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "We're available 24/7 in case you need any help.",
        imageLink: "https://drive.google.com/thumbnail?id=1igbIdHZHFVZybTUbI9Ih0AQmjyTT7Y27&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "This room has a TV with a Roku Entertainment System and HDMI port.",
        imageLink: "https://drive.google.com/thumbnail?id=1Du7hhx0X7ry3QXVFNPBP9LU6ItquZMtV&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "10inches/25cm tall matresses in every house.",
        imageLink: "https://drive.google.com/thumbnail?id=1Dbna1MUEB126_-QfkRLVVgha6553hQc_&sz=w1000"
    },
    {
        roomType: "Second Bedroom",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1phVUR1WvBJmYT2Anr1BEUhwniwApu0TL&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1NJPqfxBRHstI8oaEzSNUX4Lr0KwR5F_a&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "We offer last-minute discounts, prices are updated daily!",
        imageLink: "https://drive.google.com/thumbnail?id=10KgLUm_WUcN-GWFvfN52T0j6ckfTvj9G&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1D7I61hOZ0Tk-5G-8D4WZ088eoEesWKJ_&sz=w1000"
    },
    {
        roomType: "Garden",
        roomDescription: "Free private parking is available at this location.",
        imageLink: "https://drive.google.com/thumbnail?id=1vzDKoJQ8fQEHXGXFL525sXJ77ZHbGCNO&sz=w1000"
    }
]
export const PlumeriaImageDescriptions: IImageDescription[] = [
    {
        roomType: "Bedroom",
        roomDescription: "We're available 24/7 in case you need any help. ",
        imageLink: "https://drive.google.com/thumbnail?id=1JGQiusfHscT4pSE-1KpejP0uNLUBOTa-&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1_tsBq9D5vzz0ozq6DgfAMA3BaLC3is-O&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "We offer last-minute discounts, prices are updated daily!",
        imageLink: "https://drive.google.com/thumbnail?id=1Yt3dRvt3I0gE7OX8DMZ1x1ax-B8ly78T&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=13tzWvEYl-b6x32kJxPV4W-1--01A9z9K&sz=w1000"
    },
    {
        roomType: "Terrace",
        roomDescription: "Free private parking",
        imageLink: "https://drive.google.com/thumbnail?id=1oR1cdPpg6HHGJOqKGVakPiNNYkK8gBtU&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1SsDAb6YcODSPd3ByNtoKIOu4R8j28jFK&sz=w1000"
    }
]
export const PlumeriaImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Bathroom",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1-ZKRoDNGsf7J1DMw-J5RI8H4HFlgVAuT&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "We're available 24/7 in case you need any help.",
        imageLink: "https://drive.google.com/thumbnail?id=1igbIdHZHFVZybTUbI9Ih0AQmjyTT7Y27&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "This room has a TV with a Roku Entertainment System and HDMI port.",
        imageLink: "https://drive.google.com/thumbnail?id=1Du7hhx0X7ry3QXVFNPBP9LU6ItquZMtV&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "10inches/25cm tall matresses in every house.",
        imageLink: "https://drive.google.com/thumbnail?id=1Dbna1MUEB126_-QfkRLVVgha6553hQc_&sz=w1000"
    },
    {
        roomType: "Second Bedroom",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1phVUR1WvBJmYT2Anr1BEUhwniwApu0TL&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1NJPqfxBRHstI8oaEzSNUX4Lr0KwR5F_a&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "We offer last-minute discounts, prices are updated daily!",
        imageLink: "https://drive.google.com/thumbnail?id=10KgLUm_WUcN-GWFvfN52T0j6ckfTvj9G&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1D7I61hOZ0Tk-5G-8D4WZ088eoEesWKJ_&sz=w1000"
    },
    {
        roomType: "Garden",
        roomDescription: "Free private parking is available at this location.",
        imageLink: "https://drive.google.com/thumbnail?id=1vzDKoJQ8fQEHXGXFL525sXJ77ZHbGCNO&sz=w1000"
    }
]
export const GiuliaImageDescriptions: IImageDescription[] = [
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1yKDSO3SRCADMUeXB3mu4nTmajFdRhRqI&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "10inches/25cm tall matresses in every house.",
        imageLink: "https://drive.google.com/thumbnail?id=15YzK9sR2-30k979pFEvSQaSWUaL70I4S&sz=w1000"
    },
    {
        roomType: "Second Bedroom",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1Lp1mJ-Tgwc8WMnMOvKN2oT9wobpNOLqX&sz=w1000"
    },
    {
        roomType: "Bathroom 2",
        roomDescription: "We're available 24/7 in case you need any help.",
        imageLink: "https://drive.google.com/thumbnail?id=1LX-7Iic67neRM_w79FdmyrWDxdJiJfBr&sz=w1000"
    },
    {
        roomType: "Terrace",
        roomDescription: "Free private parking.",
        imageLink: "https://drive.google.com/thumbnail?id=1bbRn5NLsJ8cKqm0I697TMNT5z9iDASxF&sz=w1000"
    },
    {
        roomType: "Bathroom 1",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1yI3aOb2sL_IiO-6lOUbxi1TBAL650Mvd&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1xiRDZCWwEnvjnGLEGE1WkrUyo6iwnOHi&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "This room has a TV with a Roku Entertainment System and HDMI port.",
        imageLink: "https://drive.google.com/thumbnail?id=1HcR7jVW9GqLhV-X5_Luh0OWpZSIMDjHd&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "We offer last-minute discounts, prices are updated daily!",
        imageLink: "https://drive.google.com/thumbnail?id=1PPdoFxDWLSizWhHUIQ7i5W7K1WU09sTm&sz=w1000"
    }

]
export const GiuliaImageDescriptionsES: IImageDescription[] = [
    {
        roomType: "Bathroom",
        roomDescription: "We always provide towels and toiletries.",
        imageLink: "https://drive.google.com/thumbnail?id=1-ZKRoDNGsf7J1DMw-J5RI8H4HFlgVAuT&sz=w1000"
    },
    {
        roomType: "Bathroom",
        roomDescription: "We're available 24/7 in case you need any help.",
        imageLink: "https://drive.google.com/thumbnail?id=1igbIdHZHFVZybTUbI9Ih0AQmjyTT7Y27&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "This room has a TV with a Roku Entertainment System and HDMI port.",
        imageLink: "https://drive.google.com/thumbnail?id=1Du7hhx0X7ry3QXVFNPBP9LU6ItquZMtV&sz=w1000"
    },
    {
        roomType: "Master Bedroom",
        roomDescription: "10inches/25cm tall matresses in every house.",
        imageLink: "https://drive.google.com/thumbnail?id=1Dbna1MUEB126_-QfkRLVVgha6553hQc_&sz=w1000"
    },
    {
        roomType: "Second Bedroom",
        roomDescription: "Bed Linens always included.",
        imageLink: "https://drive.google.com/thumbnail?id=1phVUR1WvBJmYT2Anr1BEUhwniwApu0TL&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "Microwave, coffeemaker and blender also included.",
        imageLink: "https://drive.google.com/thumbnail?id=1NJPqfxBRHstI8oaEzSNUX4Lr0KwR5F_a&sz=w1000"
    },
    {
        roomType: "Kitchen",
        roomDescription: "We offer last-minute discounts, prices are updated daily!",
        imageLink: "https://drive.google.com/thumbnail?id=10KgLUm_WUcN-GWFvfN52T0j6ckfTvj9G&sz=w1000"
    },
    {
        roomType: "Livingroom",
        roomDescription: "100Mbps Free Wifi everywhere in your house.",
        imageLink: "https://drive.google.com/thumbnail?id=1D7I61hOZ0Tk-5G-8D4WZ088eoEesWKJ_&sz=w1000"
    },
    {
        roomType: "Garden",
        roomDescription: "Free private parking is available at this location.",
        imageLink: "https://drive.google.com/thumbnail?id=1vzDKoJQ8fQEHXGXFL525sXJ77ZHbGCNO&sz=w1000"
    }
]

export const ribHouseDataEngList: HouseDataType[] = [
    {
        name: "Villa Mar",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 5,
        houseLangCode: "VillaMar",
        parking: false,
        image: "https://drive.google.com/thumbnail?id=1cl5zzeKajmxVv5_q9cH0cvYQkCRl6kCn&sz=w1000",
        amenities: [
            {
                name: "Private Pool, Exclusive for guests of this villa",
                icon: "pool"
            },
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "2 A/C Units",
                icon: "ac"
            },
            {
                name: "Private unfenced Parking",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            }
        ],
    },
    {
        name: "Villa Coral",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 6,
        houseLangCode: "VillaCoral",
        image: "https://drive.google.com/thumbnail?id=1frKDGGLk1nJQQaxoxng6TgmUVzxTx08A&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Private Pool, Exclusive for guests of this villa",
                icon: "pool"
            },
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "2 A/C Units",
                icon: "ac"
            },
            {
                name: "Private unfenced Parking",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            }
        ],
    }]
export const houseDataEngList: HouseDataType[] = [
    {
        name: "Geco",
        guestNumber: 5,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Located in the heart of town, this house has space for up to 5 people and features a fully equipped kitchen, a bathroom, 2 A/C units, and a private parking lot. Our prime location offers easy access to both the town center and the most beautiful beaches that Puerto Viejo has to offer.<br/>   Most shops and restaurants are just a short walk away, and there is a nearby jungle path that runs along the ocean and leads to natural pools in the coral and to Cocles.<br/>    All of the spaces described here are private, including the fully equipped kitchen and bathroom. You'll have everything you need to make yourself at home.<br/>    We offer cleaning services for reservations of 5 nights or longer. Our team will contact you during your stay to coordinate a convenient time for the cleaning.<br/>   Do you have a special request? We would be more than happy to accommodate you if we can. Please don't hesitate to let us know.<br/>    If you require a pack- and - play crib during your stay, please inform us ahead of time. We'll make sure to set it up in your room during our cleaning process.",
        neighborhood: "Puerto Viejo is a popular destination for tourists from all over the world, thanks to its stunning surroundings. The town boasts immense beaches that are surrounded by tropical rainforest, as well as two National Parks (Manzanillo and Cahuita). At night, the town comes alive with a lively and active nightlife scene. When you stay here, you'll be able to fully immerse yourself in everything that makes Puerto Viejo unique.<br/>    The house is located close to beach access that eventually leads to Cocles. Along the way, you'll have the opportunity to spot a variety of animals and admire natural pools in the coral. There's even a hidden sightseeing spot waiting to be discovered!<br/>    Getting around in Puerto Viejo and its surroundings is easiest by renting a bike or a scooter. However, there is also a reliable public bus service available that can take you to Cahuita, Manzanillo, and Sixaola. If you prefer to drive, we can accommodate cars as well. We offer private parking but please let us know if you have a larger pickup truck that requires additional space. Additionally, we have a charging station by the bakery.",
        houseCode: 1,
        houseLangCode: "Geco",
        parking: true,

        image: "https://drive.google.com/thumbnail?id=1tYQxiwEXhxhv2r0_mJQhXVAHOMrE0y_2&sz=w1000",
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "Private Fenced Parking",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            },

        ],
    },
    {
        name: "Rana",
        guestNumber: 5,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Nestled in the heart of town, this charming house comfortably accommodates up to 5 guests. It boasts a fully equipped kitchen, a bathroom, two A/C units, and a private parking space. Our prime location ensures easy access to both the town center and the beaches of Puerto Viejo.<br/>     The house offers complete privacy, with all described spaces, including the kitchen and bathroom, exclusively for your use. You'll have all the amenities needed to feel at home.<br/>     You'll find most shops and restaurants within a short walking distance. Additionally, a nearby jungle path along the ocean leads to natural coral pools and Cocles.<br/>     Have a special request? We are happy to accommodate if possible. Please don't hesitate to let us know.<br/>     We strongly recommend this option if you are planning to travel with your pet, as it offers a small, fenced garden.",
        neighborhood: "Puerto Viejo is a well known destination for tourists from around the globe. The town features beautiful beaches bordered by lush tropical rainforest and is home to two National Parks, Manzanillo and Cahuita. At night, Puerto Viejo transforms with a vibrant nightlife scene. Staying here allows you to fully experience everything that makes Puerto Viejo special.<br/>     The house is conveniently situated near a beach path that eventually leads to Cocles. Along the path, you'll have the chance to observe diverse wildlife and enjoy natural coral pools. There's even a hidden sightseeing spot to discover!<br/>     Getting around Puerto Viejo and its vicinity is best done by renting a bike or a scooter. Additionally, the public bus service is available, connecting you to Cahuita, Manzanillo, and Sixaola. If you prefer driving, we can accommodate cars and provide private parking. Please inform us if you have a larger pickup truck that requires extra space.",
        houseCode: 2,
        houseLangCode: "Rana",
        image: "https://drive.google.com/thumbnail?id=1UiGI8gFf6UR5kn8Eo30u457NX8NkP95X&sz=w1000",
        parking: true,
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "Private Fenced Parking",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            }
        ],
    },
    {
        name: "Tucano",
        guestNumber: 5,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "This house offers a delightful experience in the heart of Puerto Viejo with a charming wooden apartment located above an Italian bakery. The apartment features two comfortable bedrooms, a well-equipped bathroom, a fully equipped kitchen, a lovely terrace, and two A/C units, ensuring a cozy stay.<br/>    These apartments provide private spaces, including the kitchen and bathroom, offering everything you need to feel at home. For stays of 5 nights or more, we provide complimentary cleaning services, and our team will coordinate a suitable time with you during your visit.<br/>    If you have any special requests, we're happy to accommodate them whenever possible, so don't hesitate to let us know. Should you need a pack-and-play crib for your stay, please inform us in advance, and we'll ensure it's set up in your room during the cleaning process.",
        neighborhood: "Puerto Viejo attracts visitors from all over the globe with its breathtaking landscapes. The town is renowned for its expansive beaches bordered by tropical rainforests and features two National Parks, Manzanillo and Cahuita. The nightlife here is vibrant and lively, offering a unique experience after dark. Staying in Puerto Viejo allows you to fully immerse yourself in its unique charm.<br/>    Our house is conveniently located near a beach path that leads eventually to Cocles. On your way, you can observe a variety of wildlife and enjoy the natural coral pools. A hidden sightseeing spot is also waiting to be explored!.<br/>    Exploring Puerto Viejo and its surroundings is most convenient by renting a bike or a scooter. Additionally, there is a good public bus service available that connects you to Cahuita, Manzanillo, and Sixaola. If you prefer driving, we provide private parking. Please inform us if you have a larger pickup truck that needs extra space.",
        houseCode: 3,
        houseLangCode: "Tucano",
        image: "https://drive.google.com/thumbnail?id=10qvLOMLs4_JsBIF99igVeh4baDR7EB-Q&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Private Outside Parking",
                icon: "parking"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            }

        ],
    },

    {
        name: "Pappagallo",
        guestNumber: 5,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Welcome to Kalawala, a charming complex of two apartments located in the heart of Puerto Viejo. Each apartment is built entirely of wood and is situated above a delightful Italian bakery. The apartments are equipped with everything you need for a comfortable stay, including a fully equipped kitchen, two cozy bedrooms, a lovely terrace, two A/C units, and one well equipped bathroom.<br/>    All of the spaces described here are private, including the fully equipped kitchen and bathroom. You'll have everything you need to make yourself at home.<br/>    We offer cleaning services for reservations of 5 nights or longer. Our team will contact you during your stay to coordinate a convenient time for the cleaning.<br/>    Do you have a special request? We would be more than happy to accommodate you if we can. Please don't hesitate to let us know.<br/>    If you require a pack - and - play crib during your stay, please inform us ahead of time. We'll make sure to set it up in your room during our cleaning process.",
        neighborhood: "Puerto Viejo is a popular destination for tourists from all over the world, thanks to its stunning surroundings. The town boasts immense beaches that are surrounded by tropical rainforest, as well as two National Parks (Manzanillo and Cahuita). At night, the town comes alive with a lively and active nightlife scene. When you stay here, you'll be able to fully immerse yourself in everything that makes Puerto Viejo unique.<br/>    The house is located close to beach access that eventually leads to Cocles. Along the way, you'll have the opportunity to spot a variety of animals and admire natural pools in the coral. There's even a hidden sightseeing spot waiting to be discovered!<br/>    Getting around in Puerto Viejo and its surroundings is easiest by renting a bike or a scooter. However, there is also a reliable public bus service available that can take you to Cahuita, Manzanillo, and Sixaola. If you prefer to drive, we can accommodate cars as well. We offer private parking but please let us know if you have a larger pickup truck that requires additional space. Additionally, we have a charging station by the bakery.",
        houseCode: 4,
        houseLangCode: "Pappagallo",
        image: "https://drive.google.com/thumbnail?id=1owhxss4VVXLLJAQP1ByDyBMH_NwQsIuY&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Private Outside Parking",
                icon: "parking"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            }
        ],
    },
    {
        name: "Delfin",
        guestNumber: 6,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Welcome to Reservas Kalawala. Located in the heart of town, this house accommodates up to 6 guests with fully equipped kitchen, bathroom, 2 A/C units (not in kitchen or living room), and private parking. Our prime location offers easy access to both the town center and the most beautiful beaches that Puerto Viejo has to offer.<br/>    All of the spaces described here are private, including the fully equipped kitchen and bathroom. You'll have everything you need to make yourself at home.<br/>    We offer Automated check-in and check-out with lockbox key drop-off for your convenience.<br/>    Do you have a special request? We would be more than happy to accommodate you if we can. Please don't hesitate to let us know.",
        neighborhood: "Puerto Viejo is a popular destination for tourists from all over the world, thanks to its stunning surroundings. The town boasts immense beaches that are surrounded by tropical rainforest, as well as two National Parks (Manzanillo and Cahuita). At night, the town comes alive with a lively and active nightlife scene. When you stay here, you'll be able to fully immerse yourself in everything that makes Puerto Viejo unique.<br/>    The house is located close to beach access that eventually leads to Cocles. Along the way, you'll have the opportunity to spot a variety of animals and admire natural pools in the coral. There's even a hidden sightseeing spot waiting to be discovered!<br/>    Getting around in Puerto Viejo and its surroundings is easiest by renting a bike or a scooter. However, there is also a reliable public bus service available that can take you to Cahuita, Manzanillo, and Sixaola. If you prefer to drive, we can accommodate cars as well. We offer private fenced parking.",
        houseCode: 10,
        houseLangCode: "Delfin",
        image: "https://drive.google.com/thumbnail?id=1ui0cNzHTb2WM-k59OkwnJXw77m0P7PPW&sz=w1000",
        parking: true,
        amenities: [
            {
                name: "2 Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "Bedrooms with A/C",
                icon: "ac"
            },
            {
                name: "Private Fenced Parking",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            }
        ],
    }]

export const houseDataList: HouseDataType[] = [
    {
        name: "Geco",
        guestNumber: 5,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Located in the heart of town, this house has space for up to 5 people and features a fully equipped kitchen, a bathroom, 2 A/C units, and a private parking lot. Our prime location offers easy access to both the town center and the most beautiful beaches that Puerto Viejo has to offer.<br/>   Most shops and restaurants are just a short walk away, and there is a nearby jungle path that runs along the ocean and leads to natural pools in the coral and to Cocles.<br/>    All of the spaces described here are private, including the fully equipped kitchen and bathroom. You'll have everything you need to make yourself at home.<br/>    We offer cleaning services for reservations of 5 nights or longer. Our team will contact you during your stay to coordinate a convenient time for the cleaning.<br/>   Do you have a special request? We would be more than happy to accommodate you if we can. Please don't hesitate to let us know.<br/>    If you require a pack- and - play crib during your stay, please inform us ahead of time. We'll make sure to set it up in your room during our cleaning process.",
        neighborhood: "Puerto Viejo is a popular destination for tourists from all over the world, thanks to its stunning surroundings. The town boasts immense beaches that are surrounded by tropical rainforest, as well as two National Parks (Manzanillo and Cahuita). At night, the town comes alive with a lively and active nightlife scene. When you stay here, you'll be able to fully immerse yourself in everything that makes Puerto Viejo unique.<br/>    The house is located close to beach access that eventually leads to Cocles. Along the way, you'll have the opportunity to spot a variety of animals and admire natural pools in the coral. There's even a hidden sightseeing spot waiting to be discovered!<br/>    Getting around in Puerto Viejo and its surroundings is easiest by renting a bike or a scooter. However, there is also a reliable public bus service available that can take you to Cahuita, Manzanillo, and Sixaola. If you prefer to drive, we can accommodate cars as well. We offer private parking but please let us know if you have a larger pickup truck that requires additional space. Additionally, we have a charging station by the bakery.",
        houseCode: 1,
        houseLangCode: "Geco",

        parking: true,
        image: "https://drive.google.com/thumbnail?id=1tYQxiwEXhxhv2r0_mJQhXVAHOMrE0y_2&sz=w1000",
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "Private Fenced Parking",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            },

        ],
    },
    {
        name: "Rana",
        guestNumber: 5,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Nestled in the heart of town, this charming house comfortably accommodates up to 5 guests. It boasts a fully equipped kitchen, a bathroom, two A/C units, and a private parking space. Our prime location ensures easy access to both the town center and the beaches of Puerto Viejo.<br/>     The house offers complete privacy, with all described spaces, including the kitchen and bathroom, exclusively for your use. You'll have all the amenities needed to feel at home.<br/>     You'll find most shops and restaurants within a short walking distance. Additionally, a nearby jungle path along the ocean leads to natural coral pools and Cocles.<br/>     Have a special request? We are happy to accommodate if possible. Please don't hesitate to let us know.<br/>     We strongly recommend this option if you are planning to travel with your pet, as it offers a small, fenced garden.",
        neighborhood: "Puerto Viejo is a well known destination for tourists from around the globe. The town features beautiful beaches bordered by lush tropical rainforest and is home to two National Parks, Manzanillo and Cahuita. At night, Puerto Viejo transforms with a vibrant nightlife scene. Staying here allows you to fully experience everything that makes Puerto Viejo special.<br/>     The house is conveniently situated near a beach path that eventually leads to Cocles. Along the path, you'll have the chance to observe diverse wildlife and enjoy natural coral pools. There's even a hidden sightseeing spot to discover!<br/>     Getting around Puerto Viejo and its vicinity is best done by renting a bike or a scooter. Additionally, the public bus service is available, connecting you to Cahuita, Manzanillo, and Sixaola. If you prefer driving, we can accommodate cars and provide private parking. Please inform us if you have a larger pickup truck that requires extra space.",
        houseCode: 2,
        houseLangCode: "Rana",

        image: "https://drive.google.com/thumbnail?id=1UiGI8gFf6UR5kn8Eo30u457NX8NkP95X&sz=w1000",
        parking: true,
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "Private Fenced Parking",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            }
        ],
    },
    {
        name: "Tucano",
        guestNumber: 5,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "This house offers a delightful experience in the heart of Puerto Viejo with a charming wooden apartment located above an Italian bakery. The apartment features two comfortable bedrooms, a well-equipped bathroom, a fully equipped kitchen, a lovely terrace, and two A/C units, ensuring a cozy stay.<br/>    These apartments provide private spaces, including the kitchen and bathroom, offering everything you need to feel at home. For stays of 5 nights or more, we provide complimentary cleaning services, and our team will coordinate a suitable time with you during your visit.<br/>    If you have any special requests, we're happy to accommodate them whenever possible, so don't hesitate to let us know. Should you need a pack-and-play crib for your stay, please inform us in advance, and we'll ensure it's set up in your room during the cleaning process.",
        neighborhood: "Puerto Viejo attracts visitors from all over the globe with its breathtaking landscapes. The town is renowned for its expansive beaches bordered by tropical rainforests and features two National Parks, Manzanillo and Cahuita. The nightlife here is vibrant and lively, offering a unique experience after dark. Staying in Puerto Viejo allows you to fully immerse yourself in its unique charm.<br/>    Our house is conveniently located near a beach path that leads eventually to Cocles. On your way, you can observe a variety of wildlife and enjoy the natural coral pools. A hidden sightseeing spot is also waiting to be explored!.<br/>    Exploring Puerto Viejo and its surroundings is most convenient by renting a bike or a scooter. Additionally, there is a good public bus service available that connects you to Cahuita, Manzanillo, and Sixaola. If you prefer driving, we provide private parking. Please inform us if you have a larger pickup truck that needs extra space.",
        houseCode: 3,
        houseLangCode: "Tucano",
        image: "https://drive.google.com/thumbnail?id=10qvLOMLs4_JsBIF99igVeh4baDR7EB-Q&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Outside Parking",
                icon: "parking"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            }

        ],
    },

    {
        name: "Pappagallo",
        guestNumber: 5,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Welcome to Kalawala, a charming complex of two apartments located in the heart of Puerto Viejo. Each apartment is built entirely of wood and is situated above a delightful Italian bakery. The apartments are equipped with everything you need for a comfortable stay, including a fully equipped kitchen, two cozy bedrooms, a lovely terrace, two A/C units, and one well equipped bathroom.<br/>    All of the spaces described here are private, including the fully equipped kitchen and bathroom. You'll have everything you need to make yourself at home.<br/>    We offer cleaning services for reservations of 5 nights or longer. Our team will contact you during your stay to coordinate a convenient time for the cleaning.<br/>    Do you have a special request? We would be more than happy to accommodate you if we can. Please don't hesitate to let us know.<br/>    If you require a pack - and - play crib during your stay, please inform us ahead of time. We'll make sure to set it up in your room during our cleaning process.",
        neighborhood: "Puerto Viejo is a popular destination for tourists from all over the world, thanks to its stunning surroundings. The town boasts immense beaches that are surrounded by tropical rainforest, as well as two National Parks (Manzanillo and Cahuita). At night, the town comes alive with a lively and active nightlife scene. When you stay here, you'll be able to fully immerse yourself in everything that makes Puerto Viejo unique.<br/>    The house is located close to beach access that eventually leads to Cocles. Along the way, you'll have the opportunity to spot a variety of animals and admire natural pools in the coral. There's even a hidden sightseeing spot waiting to be discovered!<br/>    Getting around in Puerto Viejo and its surroundings is easiest by renting a bike or a scooter. However, there is also a reliable public bus service available that can take you to Cahuita, Manzanillo, and Sixaola. If you prefer to drive, we can accommodate cars as well. We offer private parking but please let us know if you have a larger pickup truck that requires additional space. Additionally, we have a charging station by the bakery.",
        houseCode: 4,
        houseLangCode: "Pappagallo",
        image: "https://drive.google.com/thumbnail?id=1owhxss4VVXLLJAQP1ByDyBMH_NwQsIuY&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Outside Parking",
                icon: "parking"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            }
        ],
    },
    {
        name: "Geco",
        guestNumber: 5,
        location: "AAA Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Located in the heart of town, this house has space for up to 5 people and features a fully equipped kitchen, a bathroom, 2 A/C units, and a private parking lot. Our prime location offers easy access to both the town center and the most beautiful beaches that Puerto Viejo has to offer.<br/>   Most shops and restaurants are just a short walk away, and there is a nearby jungle path that runs along the ocean and leads to natural pools in the coral and to Cocles.<br/>    All of the spaces described here are private, including the fully equipped kitchen and bathroom. You'll have everything you need to make yourself at home.<br/>    We offer cleaning services for reservations of 5 nights or longer. Our team will contact you during your stay to coordinate a convenient time for the cleaning.<br/>   Do you have a special request? We would be more than happy to accommodate you if we can. Please don't hesitate to let us know.<br/>    If you require a pack- and - play crib during your stay, please inform us ahead of time. We'll make sure to set it up in your room during our cleaning process.",
        neighborhood: "Puerto Viejo is a popular destination for tourists from all over the world, thanks to its stunning surroundings. The town boasts immense beaches that are surrounded by tropical rainforest, as well as two National Parks (Manzanillo and Cahuita). At night, the town comes alive with a lively and active nightlife scene. When you stay here, you'll be able to fully immerse yourself in everything that makes Puerto Viejo unique.<br/>    The house is located close to beach access that eventually leads to Cocles. Along the way, you'll have the opportunity to spot a variety of animals and admire natural pools in the coral. There's even a hidden sightseeing spot waiting to be discovered!<br/>    Getting around in Puerto Viejo and its surroundings is easiest by renting a bike or a scooter. However, there is also a reliable public bus service available that can take you to Cahuita, Manzanillo, and Sixaola. If you prefer to drive, we can accommodate cars as well. We offer private parking but please let us know if you have a larger pickup truck that requires additional space. Additionally, we have a charging station by the bakery.",
        houseCode: 1,
        parking: true,
        houseLangCode: "GecoES",
        image: "https://drive.google.com/thumbnail?id=1tYQxiwEXhxhv2r0_mJQhXVAHOMrE0y_2&sz=w1000",
        amenities: [
            {
                name: "Baño Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "Parqueo Privado Encerrado",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            },

        ],
    },
    {
        name: "Rana",
        guestNumber: 5,
        location: "AAA Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Nestled in the heart of town, this charming house comfortably accommodates up to 5 guests. It boasts a fully equipped kitchen, a bathroom, two A/C units, and a private parking space. Our prime location ensures easy access to both the town center and the beaches of Puerto Viejo.<br/>     The house offers complete privacy, with all described spaces, including the kitchen and bathroom, exclusively for your use. You'll have all the amenities needed to feel at home.<br/>     You'll find most shops and restaurants within a short walking distance. Additionally, a nearby jungle path along the ocean leads to natural coral pools and Cocles.<br/>     Have a special request? We are happy to accommodate if possible. Please don't hesitate to let us know.<br/>     We strongly recommend this option if you are planning to travel with your pet, as it offers a small, fenced garden.",
        neighborhood: "Puerto Viejo is a well known destination for tourists from around the globe. The town features beautiful beaches bordered by lush tropical rainforest and is home to two National Parks, Manzanillo and Cahuita. At night, Puerto Viejo transforms with a vibrant nightlife scene. Staying here allows you to fully experience everything that makes Puerto Viejo special.<br/>     The house is conveniently situated near a beach path that eventually leads to Cocles. Along the path, you'll have the chance to observe diverse wildlife and enjoy natural coral pools. There's even a hidden sightseeing spot to discover!<br/>     Getting around Puerto Viejo and its vicinity is best done by renting a bike or a scooter. Additionally, the public bus service is available, connecting you to Cahuita, Manzanillo, and Sixaola. If you prefer driving, we can accommodate cars and provide private parking. Please inform us if you have a larger pickup truck that requires extra space.",
        houseCode: 2,
        houseLangCode: "RanaES",
        image: "https://drive.google.com/thumbnail?id=1UiGI8gFf6UR5kn8Eo30u457NX8NkP95X&sz=w1000",
        parking: true,
        amenities: [
            {
                name: "Baño Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "Parqueo Privado Encerrado",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            }
        ],
    },
    {
        name: "Tucano",
        guestNumber: 5,
        location: "AAA Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "This house offers a delightful experience in the heart of Puerto Viejo with a charming wooden apartment located above an Italian bakery. The apartment features two comfortable bedrooms, a well-equipped bathroom, a fully equipped kitchen, a lovely terrace, and two A/C units, ensuring a cozy stay.<br/>    These apartments provide private spaces, including the kitchen and bathroom, offering everything you need to feel at home. For stays of 5 nights or more, we provide complimentary cleaning services, and our team will coordinate a suitable time with you during your visit.<br/>    If you have any special requests, we're happy to accommodate them whenever possible, so don't hesitate to let us know. Should you need a pack-and-play crib for your stay, please inform us in advance, and we'll ensure it's set up in your room during the cleaning process.",
        neighborhood: "Puerto Viejo attracts visitors from all over the globe with its breathtaking landscapes. The town is renowned for its expansive beaches bordered by tropical rainforests and features two National Parks, Manzanillo and Cahuita. The nightlife here is vibrant and lively, offering a unique experience after dark. Staying in Puerto Viejo allows you to fully immerse yourself in its unique charm.<br/>    Our house is conveniently located near a beach path that leads eventually to Cocles. On your way, you can observe a variety of wildlife and enjoy the natural coral pools. A hidden sightseeing spot is also waiting to be explored!.<br/>    Exploring Puerto Viejo and its surroundings is most convenient by renting a bike or a scooter. Additionally, there is a good public bus service available that connects you to Cahuita, Manzanillo, and Sixaola. If you prefer driving, we provide private parking. Please inform us if you have a larger pickup truck that needs extra space.",
        houseCode: 3,
        houseLangCode: "TucanoES",
        image: "https://drive.google.com/thumbnail?id=10qvLOMLs4_JsBIF99igVeh4baDR7EB-Q&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Baño Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Parqueo Externo",
                icon: "parking"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            }

        ],
    },

    {
        name: "Pappagallo",
        guestNumber: 5,
        location: "AAA Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Welcome to Kalawala, a charming complex of two apartments located in the heart of Puerto Viejo. Each apartment is built entirely of wood and is situated above a delightful Italian bakery. The apartments are equipped with everything you need for a comfortable stay, including a fully equipped kitchen, two cozy bedrooms, a lovely terrace, two A/C units, and one well equipped bathroom.<br/>    All of the spaces described here are private, including the fully equipped kitchen and bathroom. You'll have everything you need to make yourself at home.<br/>    We offer cleaning services for reservations of 5 nights or longer. Our team will contact you during your stay to coordinate a convenient time for the cleaning.<br/>    Do you have a special request? We would be more than happy to accommodate you if we can. Please don't hesitate to let us know.<br/>    If you require a pack - and - play crib during your stay, please inform us ahead of time. We'll make sure to set it up in your room during our cleaning process.",
        neighborhood: "Puerto Viejo is a popular destination for tourists from all over the world, thanks to its stunning surroundings. The town boasts immense beaches that are surrounded by tropical rainforest, as well as two National Parks (Manzanillo and Cahuita). At night, the town comes alive with a lively and active nightlife scene. When you stay here, you'll be able to fully immerse yourself in everything that makes Puerto Viejo unique.<br/>    The house is located close to beach access that eventually leads to Cocles. Along the way, you'll have the opportunity to spot a variety of animals and admire natural pools in the coral. There's even a hidden sightseeing spot waiting to be discovered!<br/>    Getting around in Puerto Viejo and its surroundings is easiest by renting a bike or a scooter. However, there is also a reliable public bus service available that can take you to Cahuita, Manzanillo, and Sixaola. If you prefer to drive, we can accommodate cars as well. We offer private parking but please let us know if you have a larger pickup truck that requires additional space. Additionally, we have a charging station by the bakery.",
        houseCode: 4,
        houseLangCode: "PappagalloES",
        image: "https://drive.google.com/thumbnail?id=1owhxss4VVXLLJAQP1ByDyBMH_NwQsIuY&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Baño Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            },
            {
                name: "Parqueo Externo",
                icon: "parking"
            },
            {
                name: "Pet Friendly",
                icon: "pet"
            }
        ],
    },
    {
        name: "Delfin",
        guestNumber: 6,
        location: "Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Welcome to Reservas Kalawala. Located in the heart of town, this house accommodates up to 6 guests with fully equipped kitchen, bathroom, 2 A/C units (not in kitchen or living room), and private parking. Our prime location offers easy access to both the town center and the most beautiful beaches that Puerto Viejo has to offer.<br/>    All of the spaces described here are private, including the fully equipped kitchen and bathroom. You'll have everything you need to make yourself at home.<br/>    We offer flexible check-out with lockbox key drop-off for your convenience.<br/>    Do you have a special request? We would be more than happy to accommodate you if we can. Please don't hesitate to let us know.",
        neighborhood: "Puerto Viejo is a popular destination for tourists from all over the world, thanks to its stunning surroundings. The town boasts immense beaches that are surrounded by tropical rainforest, as well as two National Parks (Manzanillo and Cahuita). At night, the town comes alive with a lively and active nightlife scene. When you stay here, you'll be able to fully immerse yourself in everything that makes Puerto Viejo unique.<br/>    The house is located close to beach access that eventually leads to Cocles. Along the way, you'll have the opportunity to spot a variety of animals and admire natural pools in the coral. There's even a hidden sightseeing spot waiting to be discovered!<br/>    Getting around in Puerto Viejo and its surroundings is easiest by renting a bike or a scooter. However, there is also a reliable public bus service available that can take you to Cahuita, Manzanillo, and Sixaola. If you prefer to drive, we can accommodate cars as well. We offer private parking but please let us know if you have a larger pickup truck that requires additional space.",
        houseCode: 10,
        houseLangCode: "Delfin",
        image: "https://drive.google.com/thumbnail?id=1UiGI8gFf6UR5kn8Eo30u457NX8NkP95X&sz=w1000",
        parking: true,
        amenities: [
            {
                name: "2 Private Equipped Bathrooms",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "Bedrooms with A/C",
                icon: "ac"
            },
            {
                name: "Private Fenced Parking for 2 Vehicles",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            }
        ],
    },
    {
        name: "Delfín",
        guestNumber: 6,
        location: "AAA Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "Bienvenido a Reservas Kalawala. Ubicada en el corazón del pueblo, esta casa acomoda hasta 6 huéspedes con cocina totalmente equipada, baño, 2 unidades de aire acondicionado (no en cocina o sala de estar), y estacionamiento privado. Nuestra ubicación privilegiada ofrece fácil acceso tanto al centro del pueblo como a las playas más hermosas que Puerto Viejo tiene para ofrecer.<br/>    Todos los espacios descritos aquí son privados, incluyendo la cocina totalmente equipada y el baño. Tendrás todo lo que necesitas para sentirte como en casa.<br/>    Ofrecemos check-out flexible con entrega de llaves en caja de seguridad para tu conveniencia.<br/>    ¿Tienes alguna solicitud especial? Estaremos más que felices de complacerte si podemos. Por favor no dudes en hacérnoslo saber.",
        neighborhood: "Puerto Viejo es un destino popular para turistas de todo el mundo, gracias a sus impresionantes alrededores. El pueblo cuenta con playas inmensas rodeadas de selva tropical, así como dos Parques Nacionales (Manzanillo y Cahuita). Por la noche, el pueblo cobra vida con una escena nocturna animada y activa. Cuando te hospedes aquí, podrás sumergirte completamente en todo lo que hace único a Puerto Viejo.<br/>    La casa está ubicada cerca del acceso a la playa que eventualmente lleva a Cocles. En el camino, tendrás la oportunidad de observar una variedad de animales y admirar piscinas naturales en el coral. ¡Incluso hay un lugar de observación oculto esperando ser descubierto!<br/>    Moverse por Puerto Viejo y sus alrededores es más fácil alquilando una bicicleta o un scooter. Sin embargo, también hay un servicio de autobús público confiable disponible que puede llevarte a Cahuita, Manzanillo y Sixaola. Si prefieres conducir, también podemos acomodar autos. Ofrecemos estacionamiento privado, pero por favor avísanos si tienes una camioneta más grande que requiere espacio adicional.",
        houseCode: 10,
        houseLangCode: "DelfinES",
        image: "https://drive.google.com/thumbnail?id=1UiGI8gFf6UR5kn8Eo30u457NX8NkP95X&sz=w1000",
        parking: true,
        amenities: [
            {
                name: "2 Baños Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "Cuartos con A/C",
                icon: "ac"
            },
            {
                name: "Parqueo Privado Encerrado",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            }
        ],
    }
]

export const VillasDataList: HouseDataType[] = [
    {
        name: "Villa Mar",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 5,
        houseLangCode: "VillaMar",
        parking: false,
        image: "https://drive.google.com/thumbnail?id=1cl5zzeKajmxVv5_q9cH0cvYQkCRl6kCn&sz=w1000",
        amenities: [
            {
                name: "Private Pool",
                icon: "pool"
            },
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "2 A/C Units",
                icon: "ac"
            },
            {
                name: "Private unfenced Parking",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            }
        ],
    },
    {
        name: "Villa Coral",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 6,
        houseLangCode: "VillaCoral",
        image: "https://drive.google.com/thumbnail?id=1frKDGGLk1nJQQaxoxng6TgmUVzxTx08A&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Private Pool",
                icon: "pool"
            },
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "2 A/C Units",
                icon: "ac"
            },
            {
                name: "Private unfenced Parking",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            }
        ],
    }
]
export const VillasDataListES: HouseDataType[] = [
    {
        name: "Villa Mar",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 5,
        houseLangCode: "VillaMarES",
        image: "https://drive.google.com/thumbnail?id=1cl5zzeKajmxVv5_q9cH0cvYQkCRl6kCn&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Piscina Privada",
                icon: "pool"
            },
            {
                name: "Baño Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "Parqueo Externo",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            }
        ],
    },
    {
        name: "Villa Coral",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 6,
        houseLangCode: "VillaCoralES",
        parking: false,
        image: "https://drive.google.com/thumbnail?id=1frKDGGLk1nJQQaxoxng6TgmUVzxTx08A&sz=w1000",
        amenities: [
            {
                name: "Piscina Privada",
                icon: "pool"
            },
            {
                name: "Baño Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "Parqueo Externo",
                icon: "parking"
            },
            {
                name: "100Mbps WiFi",
                icon: "wifi"
            }
        ],
    },
]

export const NamDataList: HouseDataType[] = [
    {
        name: "Areka",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 7,
        houseLangCode: "Areka",
        parking: true,
        image: "https://drive.google.com/thumbnail?id=1iHyOve78WkDNdTcQcUtKkiM8rXx2iRey&sz=w1000",
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "WiFi",
                icon: "wifi"
            },
            {
                name: "Unfenced Parking",
                icon: "parking"
            }
        ],
    },
    {
        name: "Plumeria",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 8,
        houseLangCode: "Plumeria",
        image: "https://drive.google.com/thumbnail?id=1b2x2aVIjqlSws4KePOS_NVb4NItGsra1&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "WiFi",
                icon: "wifi"
            },
            {
                name: "Unfenced Parking",
                icon: "parking"
            }
        ],
    },
    {
        name: "Giulia",
        guestNumber: 4,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 9,
        houseLangCode: "Giulia",
        parking: false,
        image: "https://drive.google.com/thumbnail?id=1e0esqkSBKBdT-F2kLg5PsyF46zEWtWQ8&sz=w1000",
        amenities: [
            {
                name: "Private Equipped Bathroom",
                icon: "bath"
            },
            {
                name: "Private Equipped Kitchen",
                icon: "kitchen"
            },
            {
                name: "2 A/C",
                icon: "ac"
            },
            {
                name: "WiFi",
                icon: "wifi"
            },
            {
                name: "Unfenced Parking",
                icon: "parking"
            }
        ],
    },

]

export const NamDataListES: HouseDataType[] = [
    {
        name: "Areka",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 7,
        houseLangCode: "ArekaES",
        parking: true,
        image: "https://drive.google.com/thumbnail?id=1iHyOve78WkDNdTcQcUtKkiM8rXx2iRey&sz=w1000",
        amenities: [
            {
                name: "Baño Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "WiFi",
                icon: "wifi"
            },
            {
                name: "Parqueo Externo",
                icon: "parking"
            }
        ],
    },
    {
        name: "Plumeria",
        guestNumber: 2,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 8,
        houseLangCode: "PlumeriaES",
        image: "https://drive.google.com/thumbnail?id=1b2x2aVIjqlSws4KePOS_NVb4NItGsra1&sz=w1000",
        parking: false,
        amenities: [
            {
                name: "Baño Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "A/C",
                icon: "ac"
            },
            {
                name: "WiFi",
                icon: "wifi"
            },
            {
                name: "Parqueo Externo",
                icon: "parking"
            }
        ],
    },
    {
        name: "Giulia",
        guestNumber: 4,
        location: "Playa Chiquita, Puerto Viejo de Talamanca, Limón, Costa Rica",
        description: "",
        neighborhood: "",
        houseCode: 9,
        houseLangCode: "GiuliaES",
        parking: false,
        image: "https://drive.google.com/thumbnail?id=1e0esqkSBKBdT-F2kLg5PsyF46zEWtWQ8&sz=w1000",
        amenities: [
            {
                name: "Baño Privado Equipado",
                icon: "bath"
            },
            {
                name: "Cocina Privada Equipada",
                icon: "kitchen"
            },
            {
                name: "2 A/C",
                icon: "ac"
            },
            {
                name: "WiFi",
                icon: "wifi"
            },
            {
                name: "Parqueo Externo",
                icon: "parking"
            }
        ],
    },

]

export const PROPERTY_MARKETING_CONFIG: Record<string, PropertyMarketingContent> = {
    'Rana': {
        propertyKey: 'Rana',
        descriptiveTitle: {
            en: 'Family home, pet friendly with air conditioning',
            es: 'Casa familiar, pet friendly con aire acondicionado'
        },
        price: { crc: 80000, usd: 160 },
        socialStatement: {
            en: 'Chosen for its private internal parking and small garden for pets',
            es: 'Elegida por su parqueo privado interno y pequeño jardín para las mascotas'
        },
        featureHighlights: {
            en: [
                '📍 Walkable location in downtown Puerto Viejo',
                '🏡 Private space for up to 5 people',
                '❄️ A/C in bedrooms',
                '💻 Fast WiFi ideal for remote work',
                '🐾 Pet-friendly with outdoor space'
            ],
            es: [
                '📍 Ubicación caminable en el centro de Puerto Viejo',
                '🏡 Espacio privado para hasta 5 personas',
                '❄️ A/C en habitaciones',
                '💻 WiFi rápido ideal para trabajo remoto',
                '🐾 Pet-friendly con espacio exterior'
            ]
        }
    },
    'Geco': {
        propertyKey: 'Geco',
        descriptiveTitle: {
            en: 'Family home, pet friendly with air conditioning',
            es: 'Casa familiar, pet friendly con aire acondicionado'
        },
        price: { crc: 80000, usd: 160 },
        socialStatement: {
            en: 'Chosen for its private internal parking and small garden for pets',
            es: 'Elegida por su parqueo privado interno y pequeño jardín para las mascotas'
        },
        featureHighlights: {
            en: [
                '📍 Walkable location in downtown Puerto Viejo',
                '🏡 Private space for up to 5 people',
                '❄️ A/C in bedrooms',
                '💻 Fast WiFi ideal for remote work',
                '🐾 Pet-friendly with outdoor space'
            ],
            es: [
                '📍 Ubicación caminable en el centro de Puerto Viejo',
                '🏡 Espacio privado para hasta 5 personas',
                '❄️ A/C en habitaciones',
                '💻 WiFi rápido ideal para trabajo remoto',
                '🐾 Pet-friendly con espacio exterior'
            ]
        }
    },
    'Tucano': {
        propertyKey: 'Tucano',
        descriptiveTitle: {
            en: 'Central apartment above Italian bakery',
            es: 'Apartamento céntrico sobre panadería italiana'
        },
        price: { crc: 84000, usd: 169 },
        socialStatement: {
            en: 'Chosen for its central location perfect for bars and restaurants',
            es: 'Elegida por su ubicación céntrica perfecta para bares y restaurantes'
        },
        featureHighlights: {
            en: [
                '📍 Central location above Italian bakery',
                '🏡 Cozy apartment for up to 5 people',
                '❄️ A/C in bedrooms',
                '💻 Fast WiFi ideal for remote work',
                '🍞 15% discount at bakery downstairs'
            ],
            es: [
                '📍 Ubicación céntrica sobre panadería italiana',
                '🏡 Apartamento acogedor para hasta 5 personas',
                '❄️ A/C en habitaciones',
                '💻 WiFi rápido ideal para trabajo remoto',
                '🍞 15% descuento en panadería de abajo'
            ]
        }
    },
    'Pappagallo': {
        propertyKey: 'Pappagallo',
        descriptiveTitle: {
            en: 'Central apartment above Italian bakery',
            es: 'Apartamento céntrico sobre panadería italiana'
        },
        price: { crc: 84000, usd: 169 },
        socialStatement: {
            en: 'Chosen for its central location perfect for bars and restaurants',
            es: 'Elegida por su ubicación céntrica perfecta para bares y restaurantes'
        },
        featureHighlights: {
            en: [
                '📍 Central location above Italian bakery',
                '🏡 Cozy apartment for up to 5 people',
                '❄️ A/C in bedrooms',
                '💻 Fast WiFi ideal for remote work',
                '🍞 15% discount at bakery downstairs'
            ],
            es: [
                '📍 Ubicación céntrica sobre panadería italiana',
                '🏡 Apartamento acogedor para hasta 5 personas',
                '❄️ A/C en habitaciones',
                '💻 WiFi rápido ideal para trabajo remoto',
                '🍞 15% descuento en panadería de abajo'
            ]
        }
    },
    'VillaMar': {
        propertyKey: 'VillaMar',
        descriptiveTitle: {
            en: 'Private villa with pool for couples',
            es: 'Villa privada con piscina para parejas'
        },
        price: { crc: 99000, usd: 199 },
        socialStatement: {
            en: 'Chosen for its private pool perfect for romantic getaways',
            es: 'Elegida por su piscina privada perfecta para escapadas románticas'
        },
        featureHighlights: {
            en: [
                '🏊 Private pool exclusive for guests',
                '💑 Perfect for couples seeking privacy',
                '❄️ Full A/C throughout the villa',
                '💻 Fast WiFi with dedicated workspace',
                '🏖️ Close to beautiful Playa Chiquita'
            ],
            es: [
                '🏊 Piscina privada exclusiva para huéspedes',
                '💑 Perfecta para parejas que buscan privacidad',
                '❄️ A/C completo en toda la villa',
                '💻 WiFi rápido con espacio de trabajo dedicado',
                '🏖️ Cerca de la hermosa Playa Chiquita'
            ]
        }
    },
    'VillaCoral': {
        propertyKey: 'VillaCoral',
        descriptiveTitle: {
            en: 'Private villa with pool for couples',
            es: 'Villa privada con piscina para parejas'
        },
        price: { crc: 99000, usd: 199 },
        socialStatement: {
            en: 'Chosen for its private pool perfect for romantic getaways',
            es: 'Elegida por su piscina privada perfecta para escapadas románticas'
        },
        featureHighlights: {
            en: [
                '🏊 Private pool exclusive for guests',
                '💑 Perfect for couples seeking privacy',
                '❄️ Full A/C throughout the villa',
                '💻 Fast WiFi with dedicated workspace',
                '🏖️ Close to beautiful Playa Chiquita'
            ],
            es: [
                '🏊 Piscina privada exclusiva para huéspedes',
                '💑 Perfecta para parejas que buscan privacidad',
                '❄️ A/C completo en toda la villa',
                '💻 WiFi rápido con espacio de trabajo dedicado',
                '🏖️ Cerca de la hermosa Playa Chiquita'
            ]
        }
    },
    'Areka': {
        propertyKey: 'Areka',
        descriptiveTitle: {
            en: 'Cozy retreat perfect for couples exploring Punta Uva',
            es: 'Refugio acogedor perfecto para parejas explorando Punta Uva'
        },
        price: { crc: 49000, usd: 99 },
        socialStatement: {
            en: 'Chosen for its peaceful location',
            es: 'Elegida por su ubicación tranquila'
        },
        featureHighlights: {
            en: [
                '🏖️ 2 min drive from Punta Uva beach',
                '💑 Intimate space perfect for couples',
                '❄️ A/C for comfortable nights',
                '💻 WiFi for staying connected',
                '🚗 Outside Private parking available'
            ],
            es: [
                '🏖️ 2 min en carro de playa Punta Uva',
                '💑 Espacio íntimo perfecto para parejas',
                '❄️ A/C para noches cómodas',
                '💻 WiFi para mantenerse conectado',
                '🚗 Parqueo privado externo disponible'
            ]
        }
    },
    'Plumeria': {
        propertyKey: 'Plumeria',
        descriptiveTitle: {
            en: 'Cozy retreat perfect for couples exploring Punta Uva',
            es: 'Refugio acogedor perfecto para parejas explorando Punta Uva'
        },
        price: { crc: 49000, usd: 99 },
        socialStatement: {
            en: 'Chosen for its peaceful location',
            es: 'Elegida por su ubicación tranquila'
        },
        featureHighlights: {
            en: [
                '🏖️ 2 min drive from Punta Uva beach',
                '💑 Intimate space perfect for couples',
                '❄️ A/C for comfortable nights',
                '💻 WiFi for staying connected',
                '🚗 Outside Private parking available'
            ],
            es: [
                '🏖️ 2 min en carro de playa Punta Uva',
                '💑 Espacio íntimo perfecto para parejas',
                '❄️ A/C para noches cómodas',
                '💻 WiFi para mantenerse conectado',
                '🚗 Parqueo privado externo disponible'
            ]
        }
    },
    'Giulia': {
        propertyKey: 'Giulia',
        descriptiveTitle: {
            en: 'Family-friendly house near Punta Uva',
            es: 'Casa familiar cerca de Punta Uva'
        },
        price: { crc: 84000, usd: 169 },
        socialStatement: {
            en: 'Chosen for its family-friendly amenities and beach proximity',
            es: 'Elegida por sus comodidades familiares y proximidad a la playa'
        },
        featureHighlights: {
            en: [
                '👨‍👩‍👧‍👦 Perfect for families with children',
                '🏖️ Walking distance to Playa chiquita beach',
                '❄️ A/C in bedrooms for comfort',
                '💻 Fast WiFi for remote work',
                '🚗 Parking space available'
            ],
            es: [
                '👨‍👩‍👧‍👦 Perfecta para familias con niños',
                '🏖️ A distancia caminable de playa chiquita',
                '❄️ A/C en habitaciones para comodidad',
                '💻 WiFi rápido para trabajo remoto',
                '🚗 Espacio de parqueo disponible'
            ]
        }
    },
    'Delfin': {
        propertyKey: 'Delfin',
        descriptiveTitle: {
            en: 'Spacious house perfect for large families',
            es: 'Casa espaciosa perfecta para familias grandes'
        },
        price: { crc: 99000, usd: 199 },
        socialStatement: {
            en: 'Chosen for its spacious layout accommodating up to 6 guests',
            es: 'Elegida por su diseño espacioso que acomoda hasta 6 huéspedes'
        },
        featureHighlights: {
            en: [
                '👨‍👩‍👧‍👦 Spacious for up to 6 people',
                '🏡 Two bathrooms for convenience',
                '❄️ A/C in all bedrooms',
                '💻 Fast WiFi throughout the house',
                '🚗 Private fenced parking for 2 vehicles'
            ],
            es: [
                '👨‍👩‍👧‍👦 Espaciosa para hasta 6 personas',
                '🏡 Dos baños para conveniencia',
                '❄️ A/C en todas las habitaciones',
                '💻 WiFi rápido en toda la casa',
                '🚗 Parqueo privado cercado para 2 vehículos'
            ]
        }
    }
};

// Property recommendations for blog articles
export interface PropertyRecommendation {
  name: string;
  reason: string;
  link: string;
  houseCode?: number;
}

export const PUERTO_VIEJO_BLOG_RECOMMENDATIONS: PropertyRecommendation[] = [
  {
    name: 'Casa Geco',
    reason: 'Ideal si quieres moverte caminando',
    link: '/Geco',
    houseCode: 1
  },
  {
    name: 'Plumeria',
    reason: 'Perfecta para descansar cerca de la playa',
    link: '/Plumeria',
    houseCode: 8
  },
  {
    name: 'Villa Coral',
    reason: 'Si buscas una escapada corta con piscina privada',
    link: '/VillaCoral',
    houseCode: 6
  }
];

// General Puerto Viejo area recommendations for travel-focused blogs
export const GENERAL_PUERTO_VIEJO_RECOMMENDATIONS: PropertyRecommendation[] = [
  {
    name: 'Casa Geco',
    reason: 'Perfect for exploring on foot',
    link: '/Geco',
    houseCode: 1
  },
  {
    name: 'Plumeria',
    reason: 'Ideal for beach relaxation',
    link: '/Plumeria',
    houseCode: 8
  },
  {
    name: 'Villa Coral',
    reason: 'Great for short getaways with private pool',
    link: '/VillaCoral',
    houseCode: 6
  }
];

// Cahuita-focused recommendations
export const CAHUITA_AREA_RECOMMENDATIONS: PropertyRecommendation[] = [
  {
    name: 'Plumeria',
    reason: 'Perfect Retreat for Couples',
    link: '/Plumeria',
    houseCode: 8
  },
  {
    name: 'Casa Geco',
    reason: 'Easy access to transportation',
    link: '/Geco',
    houseCode: 1
  },
  {
    name: 'Villa Coral',
    reason: 'Perfect for relaxing after park visits',
    link: '/VillaCoral',
    houseCode: 6
  }
];

// Spanish versions for ES blog pages
export const PUERTO_VIEJO_BLOG_RECOMMENDATIONS_ES: PropertyRecommendation[] = [
  {
    name: 'Casa Geco',
    reason: 'Ideal si quieres moverte caminando',
    link: '/GecoES',
    houseCode: 1
  },
  {
    name: 'Plumeria',
    reason: 'Perfecta para descansar cerca de la playa',
    link: '/PlumeriaES',
    houseCode: 8
  },
  {
    name: 'Villa Coral',
    reason: 'Si buscas una escapada corta con piscina privada',
    link: '/VillaCoralES',
    houseCode: 6
  }
];